import { yupResolver } from '@hookform/resolvers/yup';
import { Checkbox, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import React, { useContext, useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AdministrationUserCreateForm, SortingCenter } from 'types';
import { AdministrationUserCreateStep4Schema } from './Step4.yup';
import { AdministrationUserCreateStepProps } from './types';
import { AppContext } from '../../../context';
import { transformObjectId } from '../../../services/apiPlatformTransformer';
import { useStyles } from './styles';

interface ListItemSortingCenterProps {
  sortingCenter: SortingCenter;
}

export const Step4: React.FC<AdministrationUserCreateStepProps> = ({ onSubmit, formName, previousStepData }) => {
  const context = useContext(AppContext);
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'administration.users.create' });
  const schema = useMemo(() => AdministrationUserCreateStep4Schema(t), [t]);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<AdministrationUserCreateForm>({
    mode: 'onSubmit',
    defaultValues: { ...{ sortingCenters: [] }, ...previousStepData },
    resolver: yupResolver(schema),
  });

  const ListItemSortingCenter: React.FC<ListItemSortingCenterProps> = ({ sortingCenter }) => {
    const sortingCenterId = parseInt(transformObjectId(sortingCenter), 10);
    return (
      <div className={classes.listItemContainer}>
        <ListItem>
          <ListItemText className={classes.itemLabel}>
            <Typography>
              {sortingCenter.name} - <span className={classes.primary}>{sortingCenter.code}</span>
            </Typography>
          </ListItemText>
          <ListItemIcon>
            <Controller
              name={`sortingCenters.${sortingCenterId}`}
              control={control}
              render={({ field: { ref, onChange, value, ...inputProps }, fieldState }) => (
                <Checkbox
                  id={`sortingCenters.${sortingCenterId}`}
                  color={'primary'}
                  checked={!!value}
                  value={!!value}
                  onChange={onChange}
                  inputRef={ref}
                  {...inputProps}
                />
              )}
            />
          </ListItemIcon>
        </ListItem>
      </div>
    );
  };

  const sortingCenters = context.getSortingCenters?.();
  const eligibleSortingCenterChild: SortingCenter[] = [];
  sortingCenters?.map((sortingCenter: SortingCenter) => {
    sortingCenter.childrenSortingCenter?.map(sortingCenterChild => {
      eligibleSortingCenterChild.push(sortingCenterChild);
      return null;
    });
    return null;
  });

  return (
    <form className={classes.form} id={formName} onSubmit={handleSubmit(onSubmit)}>
      <br />
      <br />
      <div className={classes.fieldHeader}>
        <Typography
          className={errors && errors.sortingCenters ? classes.sortingCentersErrors : classes.sortingCentersSuccess}
        >
          {t('sortingCenterList')}
        </Typography>
      </div>
      <div className={classes.divScroll}>
        {eligibleSortingCenterChild
          ? eligibleSortingCenterChild.map((sortingCenter: SortingCenter, index) => (
              <ListItemSortingCenter key={index} sortingCenter={sortingCenter} />
            ))
          : ''}
      </div>
      <div className={classes.treeBottom} />
    </form>
  );
};
